import { ThemeType } from '@app/api/models/Theme';
import styled from 'lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import { ReactComponent as Icon } from '../circle-08.svg';

const ThemedAvatar = styled(Icon)(({ theme }: { theme: ThemeType }) => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: theme?.colors?.icons || colors.icons,
        },
        '& circle': {
            stroke: theme?.colors?.icons || colors.icons,
        },
    };
});
const Avatar: FC = ({ ...rest }) => {
    return <ThemedAvatar {...rest} />;
};

export default Avatar;
